import { Stack, HStack, Heading, Badge, useColorModeValue } from '@ecoinvent/ui';
import mixpanel from 'mixpanel-browser';

import { Sector } from 'hooks/data/search/types';
import { MIXPANEL_EVENTS } from 'utilities/constants/mixpanel';

type SectorBadgesProps = {
  sector: string;
  subsectors: Sector[];
  icon: JSX.Element;
  selectedSubSectors: string[];
  onSelectedSubSectorsChange: (seletectedSector: string[]) => void;
};

const SectorBadges = ({ sector, subsectors, icon, selectedSubSectors, onSelectedSubSectorsChange }: SectorBadgesProps) => {
  const headingColor = useColorModeValue('gray.700', 'gray.200');
  const badgeColor = useColorModeValue('green.600', 'green.400');

  const handleSubSectorClick = (subsector: Sector) => {
    if (selectedSubSectors.includes(subsector.name)) {
      onSelectedSubSectorsChange([...selectedSubSectors.filter((selected) => selected !== subsector.name)]);
    } else {
      onSelectedSubSectorsChange([...selectedSubSectors, subsector.name]);
      mixpanel.track(MIXPANEL_EVENTS.EXPLORE_BY_FILTER, { sector, subsector });
    }
  };

  return (
    <Stack spacing={2} maxW="200px">
      <HStack minH={10}>
        {icon}
        <Heading color={headingColor} size="sm">
          {sector}
        </Heading>
      </HStack>
      <HStack spacing={2} flexWrap="wrap">
        {subsectors.map((subsector) => (
          <Badge
            color={selectedSubSectors.includes(subsector.name) ? 'white' : badgeColor}
            borderRadius="md"
            key={subsector.name}
            colorScheme="green"
            variant={selectedSubSectors.includes(subsector.name) ? 'solid' : 'outline'}
            textTransform="none"
            fontWeight="500"
            onClick={() => handleSubSectorClick(subsector)}
            cursor="pointer"
          >
            {subsector.name} {`(${subsector.count})`}
          </Badge>
        ))}
      </HStack>
    </Stack>
  );
};

export default SectorBadges;
